<template>
    <div class="bg-white p-4 sm:p-6 lg:p-8 rounded-lg shadow-lg w-full max-w-lg lg:max-w-6xl mb-8">
      <h2 class="text-lg sm:text-xl lg:text-2xl font-bold mb-4 text-gray-800">Manage Items</h2>
  
      <!-- Align Add Button to the Right -->
      <div class="flex justify-end mb-4">
        <button class="px-4 py-2 rounded-lg bg-green hover:bg-green hover:text-gray-200 text-gray-100" @click="openAddItemModal">
          Add
        </button>
      </div>
  
      <!-- Items Table -->
      <table class="w-full text-left border-collapse">
        <thead>
          <tr>
            <th class="p-2 border-b-2">Item Name</th>
            <th class="p-2 border-b-2">Quantity</th>
            <th class="p-2 border-b-2">Price (FRw)</th>
            <th class="p-2 border-b-2">Total (FRw)</th>
            <th class="p-2 border-b-2">Action</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in items" :key="index" class="hover:bg-gray-100">
            <td class="p-2 border-b">{{ item.name }}</td>
            <td class="p-2 border-b">{{ item.quantity }}</td>
            <td class="p-2 border-b">{{ item.price }}</td>
            <td class="p-2 border-b">{{ +item.price * +item.quantity }}</td>
            <td class="p-2 border-b">
              <button @click="viewItem(item)" class="text-blue-500 hover:text-blue-700 focus:outline-none px-2">
                <i class="fas fa-eye"></i>
              </button>
              <button @click="editItem(item)" class="text-gray-500 hover:text-gray-700 focus:outline-none px-2">
                <i class="fas fa-edit"></i>
              </button>
              <button @click="deleteItem(item.id)" class="text-red-500 hover:text-red-700 focus:outline-none px-2">
                <i class="fa fa-trash"></i>
              </button>
            </td>
          </tr>
          <tr v-if="items.length === 0">
            <td colspan="5" class="text-center text-gray-500 p-4">No items available.</td>
          </tr>
        </tbody>
      </table>
      <!-- Modals -->
      <AddItemModal v-if="isAddItemModalOpen" @closeModal="isAddItemModalOpen = false" />
      <ViewItemModal v-if="isViewItemModalOpen" :item="selectedItem" @closeModal="isViewItemModalOpen = false" />
      <EditItemModal v-if="isEditItemModalOpen" :item="selectedItem" @closeModal="isEditItemModalOpen = false" />
      
    </div>
  </template>
  
  <script>
  import { mapActions, mapState } from 'vuex';
  import AddItemModal from './AddItemModal.vue';
  import ViewItemModal from './ViewItemModal.vue';
  import EditItemModal from './EditItemModal.vue';

  export default {
    components : {
      AddItemModal,
      ViewItemModal,
      EditItemModal
    },
    data(){
      return{
        isAddItemModalOpen: false,
        isViewItemModalOpen: false,
        isEditItemModalOpen: false,
        selectedItem: null,
      }
    },
    computed : {
    ...mapState('items', {
      items: state => state.items,
      categories: state => state.categories,
      managementItems: state => state.managementItems,
    })
    },
    methods: {
    ...mapActions('items', {
      deleteItem : 'deleteItem'
    }),
    openAddItemModal() {
      this.isAddItemModalOpen = true;
    },
    viewItem(item) {
      this.selectedItem = item;
      this.isViewItemModalOpen = true;
    },
    editItem(item) {
      console.log(item)
      this.selectedItem = item;
      this.isEditItemModalOpen = true;
    },
    }
  };
  </script>
  